import { ref, computed, onBeforeMount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1697a9ad"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search_block"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "over-text"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "over-text"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 3
};
const _hoisted_8 = {
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_9 = {
  key: 0,
  class: "notify-user-tags"
};
const _hoisted_10 = {
  class: "tooltip-users"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "over-text"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  class: "over-text"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "over-text"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1));
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "pagination"
};
import useThresholdPlanList from './hooks/useThresholdPlanList';
import useUserList from './hooks/useUserList';
import searchBlock from './components/searchBlock.vue';
import SvgIcon from '@/components/SvgIcon';
import AddDrawer from './components/addDrawer.vue';
import { tableColumn, TASK_TRIGGER_TYPE_OPTIONS, ENABLE_STATUS, ENABLE_STATUS_OPTIONS } from './data';
import { reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import { getWarningTaskListFetch, deleteWarningTaskFetch } from '@/api/orderMonitor';
import useProductList from '../hooks/useProductList';
export default {
  __name: 'index',
  setup(__props) {
    const {
      userList,
      loading: userLoading,
      searchTip: userSearchTip,
      searchUsers,
      resetUsers
    } = useUserList();
    const {
      thresholdPlanList
    } = useThresholdPlanList();
    const {
      productList,
      isProductListLoading
    } = useProductList();
    const columns = ref(tableColumn);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const dataTotal = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const filterOptions = ref({});
    const addRef = ref(null);

    // 将产品列表转换为 Map，提升查找性能（从 O(n) 降到 O(1)）
    const productMap = computed(() => {
      var _productList$value;
      const map = new Map();
      (_productList$value = productList.value) === null || _productList$value === void 0 || _productList$value.forEach(product => {
        if (product.dbtId) {
          map.set(product.dbtId, product);
        }
      });
      return map;
    });

    // 合并 loading 状态：产品列表加载中或表格数据加载中
    const combinedLoading = computed(() => loading.value || isProductListLoading.value);
    const triggerTypeLabelMap = Object.fromEntries(TASK_TRIGGER_TYPE_OPTIONS.map(o => [o.value, o.label]));
    const enableStatusLabelMap = Object.fromEntries(ENABLE_STATUS_OPTIONS.map(o => [o.value, o.label]));
    const changePage = (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      getTable();
    };
    const onSearch = async options => {
      filterOptions.value = {
        ...options
      };
      pageIndex.value = 1;
      const startTime = new Date().getTime();
      const status = await getTable();
      const duartion = new Date().getTime() - startTime;
      reportEvent({
        eventName: '_search',
        properties: {
          ui_name: '预警任务管理-筛选',
          app_name: '',
          return_duration: duartion,
          query_status: status
        }
      });
    };
    const getParams = () => {
      const param = {
        ...filterOptions.value,
        currentPage: pageIndex.value,
        pageSize: pageSize.value
      };
      return param;
    };
    const getTable = async () => {
      try {
        loading.value = true;
        const param = getParams();
        const {
          code,
          data
        } = await getWarningTaskListFetch(param);
        if (code === '0') {
          var _data$warningTaskList, _data$total;
          tableData.value = (_data$warningTaskList = data === null || data === void 0 ? void 0 : data.warningTaskList) !== null && _data$warningTaskList !== void 0 ? _data$warningTaskList : [];
          dataTotal.value = (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0;
          return 'succeed';
        } else {
          return 'failed';
        }
      } catch (e) {
        return 'failed';
      } finally {
        loading.value = false;
      }
    };
    const addTask = record => {
      addRef.value.showModal(record);
    };
    const viewTask = record => {
      addRef.value.showView(record);
    };
    const deleRow = async taskId => {
      const {
        code
      } = await deleteWarningTaskFetch({
        taskId
      });
      if (code === '0') {
        message.success('删除成功');
        getTable();
        reportEvent({
          eventName: 'element_use',
          properties: {
            ui_name: '预警任务管理',
            element_name: '删除'
          }
        });
      }
    };
    const getProductNames = dbtIds => {
      if (!Array.isArray(dbtIds) || dbtIds.length === 0) {
        return '--';
      }
      const names = dbtIds.map(dbtId => {
        const product = productMap.value.get(dbtId);
        return (product === null || product === void 0 ? void 0 : product.appName) || (product === null || product === void 0 ? void 0 : product.label);
      }).filter(Boolean);
      return names.length > 0 ? names.join(', ') : '--';
    };
    onBeforeMount(() => {
      getTable();
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(searchBlock, {
        userList: _unref(userList),
        thresholdPlanList: _unref(thresholdPlanList),
        productList: _unref(productList),
        onSearch: onSearch
      }, null, 8, ["userList", "thresholdPlanList", "productList"]), _createElementVNode("div", null, [_createVNode(_component_a_button, {
        class: "save-button",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => addTask())
      }, {
        default: _withCtx(() => [_createVNode(_unref(SvgIcon), {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        }), _createTextVNode(" 新建预警任务 ")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_table, {
        columns: columns.value,
        dataSource: tableData.value,
        rowKey: "taskId",
        size: "small",
        loading: _unref(combinedLoading),
        pagination: false,
        class: "table-content",
        scroll: {
          x: 'max-content'
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _record$dbtIds, _record$notifyUserInf;
          return [column.dataIndex === 'taskName' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [record.taskName ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '300px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.taskName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record.taskName), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'dbtIds' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [(_record$dbtIds = record.dbtIds) !== null && _record$dbtIds !== void 0 && _record$dbtIds.length ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '300px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(getProductNames(record.dbtIds)), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(getProductNames(record.dbtIds)), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'enable' ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(record.enable === _unref(ENABLE_STATUS).ON ? 'nomal-tagbgc-green' : 'nomal-tagbgc-red')
          }, _toDisplayString(_unref(enableStatusLabelMap)[record.enable] || '--'), 3)) : _createCommentVNode("", true), column.dataIndex === 'triggerType' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(triggerTypeLabelMap)[record.triggerType] || '--'), 1)) : _createCommentVNode("", true), column.dataIndex === 'createTime' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [record.createTime ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '800px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.createTime), 1)]),
            default: _withCtx(() => {
              var _record$createTime;
              return [_createElementVNode("div", _hoisted_8, _toDisplayString((_record$createTime = record.createTime) === null || _record$createTime === void 0 ? void 0 : _record$createTime.split(' ')[0]), 1)];
            }),
            _: 2
          }, 1024)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'notifyUserInfo' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [(_record$notifyUserInf = record.notifyUserInfo) !== null && _record$notifyUserInf !== void 0 && _record$notifyUserInf.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.notifyUserInfo, (user, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: user.notifyUserId
            }, [index < 3 ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              class: "user-tag"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(user.notifyUser), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 64);
          }), 128)), record.notifyUserInfo.length > 3 ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '400px'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(record.notifyUserInfo.slice(3).map(item => item.notifyUser).join('、')), 1)]),
            default: _withCtx(() => [_createVNode(_component_a_tag, {
              class: "more-tag"
            }, {
              default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(record.notifyUserInfo.length - 3), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_11, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'notifyFeishuChatName' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [record.notifyFeishuChatName ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '400px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.notifyFeishuChatName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(record.notifyFeishuChatName), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_13, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'createUser' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [record.createUser ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft",
            overlayStyle: {
              maxWidth: '400px'
            }
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.createUser), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString(record.createUser), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_15, "--"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'remark' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 8,
            placement: "topLeft",
            "auto-adjust-overflow": false,
            overlayStyle: {
              maxWidth: '300px'
            }
          }, _createSlots({
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(record.remark || '--'), 1)]),
            _: 2
          }, [record.remark ? {
            name: "title",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(record.remark), 1)]),
            key: "0"
          } : undefined]), 1024)) : _createCommentVNode("", true), column.dataIndex === 'action' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 9
          }, [true ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("a", {
            onClick: $event => addTask(record),
            class: "m-r-8"
          }, "编辑", 8, _hoisted_17), _createVNode(_component_a_popconfirm, {
            title: "确定删除吗?",
            placement: "topRight",
            onConfirm: $event => deleRow(record.taskId),
            arrowPointAtCenter: ""
          }, {
            default: _withCtx(() => [_hoisted_18]),
            _: 2
          }, 1032, ["onConfirm"])], 64)) : (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: $event => viewTask(record)
          }, "查看", 8, _hoisted_19))], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[1] || (_cache[1] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        total: dataTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"])])]), _createVNode(AddDrawer, {
        ref_key: "addRef",
        ref: addRef,
        userList: _unref(userList),
        userLoading: _unref(userLoading),
        userSearchTip: _unref(userSearchTip),
        onSearchUsers: _unref(searchUsers),
        onOpenUsers: _cache[3] || (_cache[3] = $event => _unref(searchUsers)()),
        onCloseUsers: _unref(resetUsers),
        thresholdPlanList: _unref(thresholdPlanList),
        productList: _unref(productList),
        onReflashTable: getTable
      }, null, 8, ["userList", "userLoading", "userSearchTip", "onSearchUsers", "onCloseUsers", "thresholdPlanList", "productList"])]);
    };
  }
};